import React from 'react';
import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './ImpersonationBanner.css';

interface ImpersonationBannerProps {
  farmName?: string;
  userId?: string;
  onExit: () => void;
}

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ farmName, userId, onExit }) => {
  const { t } = useTranslation();
  const displayName = farmName || userId || '—';

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner__text">
        {t('admin.impersonating', 'Anzeige als:')} <strong>{displayName}</strong>
      </span>
      <button
        className="impersonation-banner__exit"
        onClick={onExit}
        title={t('admin.stopImpersonation', 'Beenden')}
      >
        <LogOut size={14} />
      </button>
    </div>
  );
};

export default ImpersonationBanner;
